import React, { useState } from 'react'
import { Input, Label } from '../../../styles/newStyles/Register.styled'
import styled from 'styled-components'
import { BsEyeFill } from 'react-icons/bs'
import { IoEye, IoEyeOff } from 'react-icons/io5'
import { Text } from '../../../modules/staking'

const SetPasswordForm = ({ password, onPasswordChange, setValidationStatus }) => {
    const [confirmPassword, setConfirmPassword] = useState('')
    const [errors, setErrors] = useState({ password: '', confirmPassword: '' })
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)

    const togglePassword = () => setShowPassword(prev => !prev)
    const toggleConfirm = () => setShowConfirm(prev => !prev)

    const validatePassword = (value) => {
        const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
        if (!value) {
            setValidationStatus('error')
            return 'رمز عبور الزامی است.'
        }
        if (!regex.test(value)) {
            setValidationStatus('error')
            return 'رمز عبور باید حداقل ۸ کاراکتر شامل حروف بزرگ، حروف کوچک، اعداد و نمادها باشد.'
        }
        setValidationStatus('valid')
        return ''
    }

    const handlePasswordChange = (value) => {
        const onlyEnglishRegex = /^[\x00-\x7F]*$/
        if (!onlyEnglishRegex.test(value)) return
        onPasswordChange(value)
        setErrors({
            ...errors,
            password: validatePassword(value),
            confirmPassword: confirmPassword && value !== confirmPassword ? 'رمز عبور با تاییدیه همخوانی ندارد' : '',
        })
    }

    const handleConfirmChange = (value) => {
        const onlyEnglishRegex = /^[\x00-\x7F]*$/
        if (!onlyEnglishRegex.test(value)) return
        setConfirmPassword(value)
        setErrors({
            ...errors,
            confirmPassword: value !== password ? 'رمز عبور با تاییدیه همخوانی ندارد' : '',
        })
    }

    return (
        <div className='flex flex-col gap-4 mt-4'>
            <div>
                <Label>
                    <Text tid="choose-new-password" />
                </Label>
                <div className='relative'>
                    <Input
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={e => handlePasswordChange(e.target.value)}
                        placeholder="رمز عبور"
                    />
                    <button
                        type="button"
                        onClick={togglePassword}
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-xs"
                    >
                        {showPassword ? <IoEye size={22} /> : <IoEyeOff size={22} />}
                    </button>
                </div>
                {errors.password && <ErrorMessage>{errors.password}</ErrorMessage>}
            </div>

            <div>
                <Label>
                    <Text tid="confirm-new-password" />
                </Label>
                <div className='relative'>
                    <Input
                        type={showConfirm ? 'text' : 'password'}
                        value={confirmPassword}
                        onChange={e => handleConfirmChange(e.target.value)}
                        placeholder="تکرار رمز عبور"
                    />
                    <button
                        type="button"
                        onClick={toggleConfirm}
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-xs"
                    >
                        {showPassword ? <IoEye size={22} /> : <IoEyeOff size={22} />}
                    </button>
                </div>
                {errors.confirmPassword && <ErrorMessage>{errors.confirmPassword}</ErrorMessage>}
            </div>
        </div>
    )
}

export default SetPasswordForm

export const ErrorMessage = styled.div`
	color: #e74c3c;
	font-size: 0.875rem;
	margin-top: 0.25rem;
`